import { Callback, CallbackAsync } from '@csp/csp-common-model';
import { useMaybeAnalyticsContext } from '@csp/csp-web-analytics';
import { noop } from 'lodash';
import { useCallback } from 'react';
import { useAppDispatch } from '../../../common/hooks/useAppDispatch';
import { WebContentCacheProviderFactory } from '../../../system/service/WebContentCacheProviderFactory';
import { UnifyTrackingEvent } from '../../analytics/UnifyTrackingEvent';
import { useConsentContext } from '../../consent/context/hook/useConsentContext';
import { signOutPrincipalThunk } from '../ducks/principalContextActions';

type SignOutHook = {
  signOut: CallbackAsync;
};

export const useSignOut = (onAfterSignOutCallback: Callback = noop): SignOutHook => {
  const dispatch = useAppDispatch();
  const { resetConsents } = useConsentContext();
  const analytics = useMaybeAnalyticsContext();

  const signOut: CallbackAsync = useCallback(async (): Promise<void> => {
    const contentCacheProvider = WebContentCacheProviderFactory();

    await contentCacheProvider.clear();
    await analytics?.track(UnifyTrackingEvent.SIGN_OUT);
    // signOutPrincipalThunk will handle the redirect to the login page
    await dispatch(signOutPrincipalThunk());

    resetConsents();
    onAfterSignOutCallback();
  }, [onAfterSignOutCallback, dispatch, resetConsents, analytics]);

  return { signOut };
};
